import { init } from './init'
import { dispatch } from './dispatch'

export const actions = Object.assign({}, init, dispatch)
